(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oc-announcement')) {
    customElements.define('oc-announcement', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = Array.from(this.querySelectorAll('.oc-announcement__slide'));
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.editing = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.live = this.querySelector('.oc-announcement__slides');
        this.pauseButton = this.querySelector('[data-action="pause"]');
        const controls = this.querySelector('.oc-announcement__controls');
        if (controls) controls.hidden = false;
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-action]');
          if (!button || !this.contains(button)) return;
          if (button.dataset.action === 'pause') {
            this.paused = !this.paused;
            button.setAttribute('aria-pressed', String(this.paused));
            button.setAttribute('aria-label', this.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
            button.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
          } else {
            this.show(this.index + (button.dataset.action === 'next' ? 1 : -1));
          }
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => this.schedule(), options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editing = true;
          this.show(index);
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
          this.editing = false;
          this.schedule();
        }, options);
        this.show(0);
        this.schedule();
      }
      show(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => {
          const active = position === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
      }
      schedule() {
        clearTimeout(this.timer);
        const running = this.slides.length > 1 && this.dataset.autoplay === 'true' && !this.paused && !this.hovered && !this.focused && !this.editing && !document.hidden && !this.motion.matches;
        this.live.setAttribute('aria-live', running ? 'off' : 'polite');
        if (this.pauseButton) this.pauseButton.hidden = this.dataset.autoplay !== 'true' || this.motion.matches;
        if (running) this.timer = setTimeout(() => {
          this.show(this.index + 1);
          this.schedule();
        }, Math.max(2000, Number(this.dataset.interval) || 5000));
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
